import { doc, setDoc, collection, getDocs, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "ConfigFirebase";
import { deleteProductAPI } from "./Product";

export async function addNewOilBrandAPI(brand) {

  let status = true;
  try {
    const brandRef = doc(db, 'oilBrands', brand.name);
    await setDoc(brandRef, brand, { merge: true });
  }
  catch (e) {
    status = false;
  }
  return status;
}

export async function deleteOilBrandAPI(brand) {

  let status = true;
  try {
    const brandRef = doc(db, 'oilBrands', brand.name);
    await deleteDoc(brandRef);

    //Elimina productos con el modelo anterior
    const arrayProducts = await getDocs(collection(db, 'Ac'));
    arrayProducts.forEach(async (Doc) => {
      let item = Doc.data();
      if (item.brandOil === brand.name) {
        await deleteProductAPI(Doc.id, 'Ac');
      }
    });
  }
  catch (e) {
    status = false;
  }
  return status;
}

export async function getOilBrandsAPI() {

  const clln = collection(db, "oilBrands");
  const querySnapshot = await getDocs(clln);
  let docsData = [];
  querySnapshot.forEach((doc) => {
    const item = { ...doc.data() };
    docsData.push(item.name);
  });

  return docsData;
}

export async function editBrandOil(brandName, newName) {
  let status = true;
  try {
    await deleteOilBrandAPI({ name: brandName });
    await addNewOilBrandAPI({ name: newName });

    //Actualiza productos con el modelo anterior
    const categories = ['Ac'];
    for (const idx in categories) {
      let cat = categories[idx]
      const arrayProducts = await getDocs(collection(db, cat));
      arrayProducts.forEach(async (Doc) => {
        let item = Doc.data();
        if (item.brandOil === brandName) {
          let productRef = doc(db, cat, Doc.id);
          await updateDoc(productRef, {
            brandOil: newName,
          });
        }
      });
    }
  }
  catch (e) {
    status = false;
  }
  return status;
}